import React from 'react';

const Playhead = ({
  position,
  currentTime,
  onMouseDown,
  isDragging
}) => {
  // Format time display
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    const frames = Math.floor((seconds % 1) * 25); // 25 FPS
    return `${mins.toString().padStart(2, '0')}.${secs.toString().padStart(2, '0')}.${frames.toString().padStart(2, '0')}`;
  };

  return (
    <div
      className="absolute top-0"
      style={{
        left: `${position}%`,
        transform: 'translateX(-50%)',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 2
      }}
    >

      {/* Square handle at the top */}
      <div
        data-playhead-handle
        className={`absolute bg-ag-black-800 text-white text-center
                    text-[10px] px-1 py-1 rounded font-bold shadow-lg border border-ag-black-600 transition-colors ${isDragging ? 'bg-ag-green-dark cursor-grabbing' : 'hover:bg-ag-green-dark cursor-grabbing'
          }`}
        style={{
          top: '17px',
          width: '58px',
          height: '30px',
          transform: 'translateX(-50%)',
          borderRadius: '6px',
          pointerEvents: 'auto',
          border: '2px solid rgba(255, 255, 255, 0.3)',
          zIndex: 1
        }}
        onMouseDown={onMouseDown}
      >
        {formatTime(currentTime)}
      </div>

      {/* Vertical line extending down */}
      <div
        className="absolute bottom-0 w-[2px] bg-ag-green opacity-80"
        style={{
          top: '20px', // Start below the handle
          transform: 'translateX(-50%)',
          pointerEvents: 'none',
          boxShadow: '0 0 4px rgba(16, 185, 129, 0.5)',
          zIndex: 0
        }}
      />
    </div>
  );
};

export default Playhead;